import { combineReducers } from "redux";
import adminReducer from "./admin_reducer";
import companiesReducer from "./companies_reducer";
import transponderReducer from "./transponder_reducer";
import moduleReducer from "./module_reducer";
import authReducer from "./auth_reducer";
import systemReducer from "./system_reducer";
import controllerReducer from "./controller_reducer";
import logsReducer from "./logs_reducer";
import raceReducer from "./race_reducer";
import subscriberReducer from "./subscriber_reducer";
import subscriptionsReducer from "./subscriptions_reducer";
import calendarReducer from "./calendar_reducer";
import { reducer as notifications } from "react-notification-system-redux";

const appReducer = combineReducers({
  authR: authReducer,
  transponderR: transponderReducer,
  adminR: adminReducer,
  moduleR: moduleReducer,
  systemR: systemReducer,
  logsR: logsReducer,
  controllerR: controllerReducer,
  notifications: notifications,
  raceR: raceReducer,
  subscriberR: subscriberReducer,
  subscriptionsR: subscriptionsReducer,
  companiesR: companiesReducer,
  calendarR: calendarReducer
});

const rootReducer = (state, action) => {
  if (action.type === "USER_LOGOUT") {
    console.log("USER LOGOUT - CLEARING REDUX STORE");
    state = undefined;
  }
  if (action.type === "SESSION_TIMEOUT") {
    console.log("SESSION TIMEOUT - CLEARING REDUX STORE");
    state = undefined;
  }
  if (action.type === "USER_TIMEOUT") {
    console.log("USER TIMEOUT - CLEARING REDUX STORE");
    state = undefined;
  }
  return appReducer(state, action);
};

export default rootReducer;
